module.exports = __webpack_public_path__ + "static/media/anc4kz.91e5c20a.pdf";